export const juniorBusinessPlanningResume = `
【職務概要】
経営企画職として2年半の実務経験を有し、中期経営計画の策定支援、事業計画の進捗管理、経営会議の運営、子会社の業績管理などを担当してきました。特に予実管理とKPI設定・モニタリングを得意としており、各部門の特性を理解した上で経営目標の達成に向けた仕組み作りに注力しています。

前職ではBIツールを活用したダッシュボード構築や経営分析レポートの作成を通じて、データドリブンな意思決定をサポートしてきました。また、新規事業立ち上げにおける事業性評価や投資判断のための資料作成にも携わり、財務・会計知識と市場分析力を駆使して貢献してきました。

近年の企業の人的資本経営や非財務情報開示の流れにも関心を持ち、統合報告書の作成支援や社内の人材データ分析にも取り組んでいます。DX推進による業務効率化と経営情報の可視化を今後の課題と捉え、積極的に学びを深めています。

【職務経歴】
・株式会社Algomaticグローバル（2022年4月〜現在）
 ○会社概要：海外3カ国に子会社を持つ製造業、従業員1,200名、年商400億円
 ○職務内容：経営企画部 経営企画課 アシスタントマネージャー
  1. 海外子会社の業績管理（月次・四半期・年次）
   - 各国拠点の事業計画に対する進捗状況の把握、差異要因分析
   - 海外子会社と本社間の業績レビュー会議の事務局運営
   - 予実管理の仕組み改善（BIツールを導入し、レポーティング自動化）
  2. 中期経営計画策定支援
   - 市場環境・競合分析資料の作成
   - 各事業部との調整・ヒアリング
   - 経営層への資料作成・プレゼンテーション
  3. 投資案件の審査
   - 海外子会社からの設備投資提案の分析と評価
   - 投資判断会議での説明資料作成
 ○成果：
  - 海外子会社の業績モニタリング体制を刷新し、問題点の早期発見・対応が可能になった
  - Power BIを活用した経営ダッシュボードを構築し、経営会議での議論の質を向上
  - 若手メンバーとして本社と海外子会社の橋渡し役を担い、コミュニケーション改善に貢献
 ○使用ツール：Excel、PowerPoint、Power BI、Tableau、SAP

・株式会社Algomaticアドバイザリー（2021年4月〜2022年3月）
 ○会社概要：経営コンサルティングファーム、従業員150名
 ○職務内容：コンサルタント
  1. 中堅企業向け経営改革プロジェクト支援
   - 経営計画策定支援
   - KPI設計と管理体制構築
   - 業務プロセス改善
  2. M&A案件支援
   - デューデリジェンス実施補助
   - 財務モデル作成
   - 統合計画策定支援
 ○成果：
  - 製造業クライアントの経営計画策定から実行までの一貫したサポートを担当
  - 事業部制への組織改革に伴う管理会計の仕組み構築に貢献
 ○使用ツール：Excel、PowerPoint、Tableau

【受賞・表彰歴】
・2023年度 株式会社Algomaticグローバル 社長賞
 ○海外子会社の業績管理体制刷新プロジェクトでの貢献が評価
・2022年度 株式会社Algomaticグローバル 新人賞
 ○入社1年目で海外子会社との円滑な連携体制構築に貢献したことが評価

【資格】
・公認会計士試験 短答式試験合格（2022年12月）
・TOEIC 850点（2022年10月）
・簿記1級（2020年11月）
・中小企業診断士（2023年3月）

【マネジメント経験】
・海外子会社業績管理プロジェクトチーム（4名）のリーダー（2023年1月〜現在）
 ○各国担当者との連携体制を構築し、レポーティングプロセスを標準化
 ○新たな業績管理フレームワークを提案し、全社展開を実現
・新卒社員の育成担当（2023年4月〜現在）
 ○新卒1名への業務指導・メンタリング
 ○経営企画業務の基礎的スキル習得プログラム作成

【語学力】
・英語：ビジネスレベル（TOEIC 850点）
 ○海外子会社とのミーティング、メールでのコミュニケーション
 ○英文資料作成、翻訳業務
・中国語：初級レベル
 ○簡単な会話、挨拶程度
 ○現在、中国子会社とのコミュニケーション向上のため学習中
` as const;
